
export const NOT_ALL_QUESTIONS_ANSWERED = -1;
export const SURVEY_SUBMISSION_SUCCESS = 1;

export const NOT_ALL_QUESTIONS_ANSWERED_MESSAGE = {
  EN: "There was an issue saving your responses. Please reload this page and take the survey again. Our apologies for the inconvenience.",
  FR: "Il y a eu un problème lors de l'enregistrement de vos réponses. Veuillez recharger cette page et reprendre l'enquête. Nous nous excusons pour le désagrément.",
};

export const ATTESTATION_MESSAGE = "Do you agree with your personal data being processed as described below and in our privacy statement?";